
import logger from "../utils/logger";

import { AuthenticationService } from "../services/authenticationService";
import { useDispatch } from "react-redux";
import { setDisable } from "../redux/slices/privateRouteAuthorizations";
import { requestLogout } from "../helper/auth/logAuth";


export const useLogout = () => {
  const dispatch = useDispatch()

  const logout = async () => {
    try {

      
      const response = await AuthenticationService.logout()

      logger.warn('response logout: ', response)


      // dispatch(setDisable()) 
      requestLogout()

    } catch (error) {
      
      logger.error("Error al cerrar sesión", error)
      // dispatch(setDisable())   
      
      requestLogout()
    }
  };

  return logout

};